
import { Item } from "@dndModels/item/ItemModel";
import { 
  IStringAnyHash 
} from "@models";
import { 
  RollPlus,
} from "@dndModels";
import { AmmunitionType, AttackType, DamageType, EffectType, isAttackType, isDamageType, WeaponType } from "@dndModels/Types";
import { WEAPON_TYPES } from "@dndModels/Constants";

export class Weapon extends Item {
  weapon_type: WeaponType = "None";
  weapon_keyword_ids: string[] = [];
  reach = 0;
  range = 0;
  range2 = 0;
  attacks: { [type: string]: { rolls: RollPlus[], uses_proficiency_id: string } } = {}; // Melee, Ranged, Thrown
  stackable = false;
  bundle_size = 1;
  ammunition_type: AmmunitionType = "None";
  weapon_mastery_property_id = "";
  uses_proficiency_id = ""; // This is the default for the weapon.  It may have attacks that use a different proficiency (ex: Daggers use Short blade for melee, and Thrown for thrown)
  required_proficiency_level = 1; // If the appropriate proficiency is present, but not the appropriate level then only half the proficiency die roll is added.

  constructor(obj?: any) {
    super(obj);
    this.item_type = "Weapon";
    this.weapon_keyword_ids = obj && obj.weapon_keyword_ids ? [...obj.weapon_keyword_ids] : [];
    if (obj) {
      // if (this.name === "Dagger") {
      //   debugger;
      // }
      this.attacks = {};
      if (obj.attacks) {
        const keys = Object.keys(obj.attacks).filter(o => o !== "");
        for (const key of keys) {
          const rolls: any[] = [];
          if (obj.attacks[key].rolls) {
            for (const roll of obj.attacks[key].rolls) {
              rolls.push(new RollPlus(roll));
            }
          } else {
            // Old way
            for (const roll of obj.attacks[key]) {
              rolls.push(new RollPlus(roll));
            }
          }
          const uses_proficiency_id = obj.attacks[key].uses_proficiency_id ? obj.attacks[key].uses_proficiency_id : "";
          this.attacks[key] = { rolls, uses_proficiency_id };
        }
      }
      this.range = obj.range ? obj.range : 0;
      this.range2 = obj.range2 ? obj.range2 : 0;
      this.reach = obj.reach ? obj.reach : 0;
      this.stackable = obj.stackable ? obj.stackable : false;
      this.bundle_size = obj.bundle_size ? obj.bundle_size : 1;
      this.weapon_mastery_property_id = obj.weapon_mastery_property_id ? obj.weapon_mastery_property_id : "";
      this.uses_proficiency_id = obj.uses_proficiency_id ? obj.uses_proficiency_id : "";
      this.required_proficiency_level = obj.required_proficiency_level ? obj.required_proficiency_level : 1;
      this.ammunition_type = obj.ammunition_type ? obj.ammunition_type : "None";
      this.weapon_type = obj.weapon_type ? obj.weapon_type : "None";
      if (!obj.weapon_type) {
        if (WEAPON_TYPES.includes(this.name)) {
          this.weapon_type = this.name as WeaponType;
        }
      }
      if (!this.weapon_keyword_ids.includes("5fd12cd67a9c0d15f0a8783c")) {
        this.reach = 0;
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   this.weapon_keyword_ids = obj && obj.weapon_keyword_ids ? [...obj.weapon_keyword_ids] : [];
  //   if (obj) {
  //     // if (this.name === "Dagger") {
  //     //   debugger;
  //     // }
  //     this.attacks = {};
  //     if (obj.attacks) {
  //       const keys = Object.keys(obj.attacks).filter(o => o !== "");
  //       for (const key of keys) {
  //         const rolls: any[] = [];
  //         if (obj.attacks[key].rolls) {
  //           for (const roll of obj.attacks[key].rolls) {
  //             rolls.push(new RollPlus(roll));
  //           }
  //         } else {
  //           // Old way
  //           for (const roll of obj.attacks[key]) {
  //             rolls.push(new RollPlus(roll));
  //           }
  //         }
  //         const uses_proficiency_id = obj.attacks[key].uses_proficiency_id ? obj.attacks[key].uses_proficiency_id : "";
  //         this.attacks[key] = { rolls, uses_proficiency_id };
  //       }
  //     }
  //     this.range = obj.range ? obj.range : 0;
  //     this.range2 = obj.range2 ? obj.range2 : 0;
  //     this.reach = obj.reach ? obj.reach : 0;
  //     this.stackable = obj.stackable ? obj.stackable : false;
  //     this.bundle_size = obj.bundle_size ? obj.bundle_size : 1;
  //     this.weapon_mastery_property_id = obj.weapon_mastery_property_id ? obj.weapon_mastery_property_id : "";
  //     this.uses_proficiency_id = obj.uses_proficiency_id ? obj.uses_proficiency_id : "";
  //     this.required_proficiency_level = obj.required_proficiency_level ? obj.required_proficiency_level : 1;
  //     this.ammunition_type = obj.ammunition_type ? obj.ammunition_type : "None";
  //     this.weapon_type = obj.weapon_type ? obj.weapon_type : "None";
  //     if (!obj.weapon_type) {
  //       if (WEAPON_TYPES.includes(this.name)) {
  //         this.weapon_type = this.name as WeaponType;
  //       }
  //     }
  //     if (!this.weapon_keyword_ids.includes("5fd12cd67a9c0d15f0a8783c")) {
  //       this.reach = 0;
  //     }
  //   }
  // }

  get the_effect_types(): EffectType[] {
    if (this.loaded) {
      if (this.weapon_attack_dts.length > 0) {
        return [...this.feature_bases.flatMap(o => o.the_effect_types),"Damage"];
      } else {
        return this.feature_bases.flatMap(o => o.the_effect_types);
      }
    } else {
      return super.get_the_effect_types();
    }
  }

  get weapon_attack_dts() {
    const dts: DamageType[] = [];
    const keys = Object.keys(this.attacks);
    for (const attack_type of keys) {
      const attack = this.attacks[attack_type];
      for (const roll of attack.rolls) {
        if (isDamageType(roll.type) && !dts.includes(roll.type)) {
          dts.push(roll.type);
        }
      }
    }
    return dts;
  }

  get the_damage_types(): (DamageType | "Selectable" | "Unarmed" | "Selectable Key" | "Use Extra")[] {
    if (this.loaded) {
      return [...this.feature_bases.flatMap(o => o.damage_types),...this.weapon_attack_dts];
    } else {
      return super.get_the_damage_types();
    }
  }

  get the_attack_types(): AttackType[] {
    if (this.loaded) {
      const ats = this.feature_bases.flatMap(o => o.the_attack_types);
      const keys = Object.keys(this.attacks);
      for (const at of keys) {
        if (isAttackType(at)) {
          ats.push(at);
        }
      }
      return ats;
    } else {
      return super.get_the_attack_types();
    }
  }

  toDBObj(): any {
    const attacks: IStringAnyHash = {};
    Object.keys(this.attacks).forEach(key => {
      const rolls: any[] = [];
      const damages = this.attacks[key].rolls as RollPlus[];
      damages.forEach(damage => {
        rolls.push(damage.toDBObj());
      });
      attacks[key] = { rolls, uses_proficiency_id: this.attacks[key].uses_proficiency_id };
    });
    const base_db_obj = super.toDBObj();
    return {
      ...base_db_obj,
      item_type: this.item_type,
      weight: this.weight,
      weapon_keyword_ids: this.weapon_keyword_ids,
      attacks,
      reach: this.reach,
      range: this.range,
      range2: this.range2,
      cost: this.cost,
      stackable: this.stackable,
      bundle_size: this.bundle_size,
      weapon_mastery_property_id: this.weapon_mastery_property_id,
      uses_proficiency_id: this.uses_proficiency_id,
      required_proficiency_level: this.required_proficiency_level,
      ammunition_type: this.ammunition_type,
      weapon_type: this.weapon_type
    };
  }

  toLight(): any {
    const base_db_obj = super.toLight();
    return {
      ...base_db_obj,
      item_type: this.item_type,
      weight: this.weight,
      weapon_keyword_ids: this.weapon_keyword_ids,
      reach: this.reach,
      range: this.range,
      range2: this.range2,
      cost: this.cost,
      stackable: this.stackable,
      bundle_size: this.bundle_size,
      weapon_mastery_property_id: this.weapon_mastery_property_id,
      uses_proficiency_id: this.uses_proficiency_id,
      required_proficiency_level: this.required_proficiency_level,
      ammunition_type: this.ammunition_type,
      weapon_type: this.weapon_type
    };
  }

  copy(copyMe: Weapon, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    this.item_type = copyMe.item_type;
    this.b_weight = copyMe.b_weight;
    this.cost = copyMe.cost;
    // this.magical = copyMe.magical;
    this.weight = copyMe.weight;
    this.weapon_keyword_ids = [...copyMe.weapon_keyword_ids];
    this.attacks = {};
    const keys = Object.keys(copyMe.attacks);
    for (const key of keys) {
      this.attacks[key] = { rolls: copyMe.attacks[key].rolls.map(o => o.clone()), uses_proficiency_id: copyMe.attacks[key].uses_proficiency_id };
    }

    // this.attack_damages = copyMe.attack_damages;
    // this.versatile_attack_damages = copyMe.versatile_attack_damages;
    // this.damage_type = copyMe.damage_type;
    this.reach = copyMe.reach;
    this.range = copyMe.range;
    this.range2 = copyMe.range2;
    // this.weapon_keyword_names = copyMe.weapon_keyword_names;
    this.cost = copyMe.cost;
    this.stackable = copyMe.stackable;
    this.bundle_size = copyMe.bundle_size;
    this.weapon_mastery_property_id = copyMe.weapon_mastery_property_id;
    this.uses_proficiency_id = copyMe.uses_proficiency_id;
    this.required_proficiency_level = copyMe.required_proficiency_level;
    this.ammunition_type = copyMe.ammunition_type;
    this.weapon_type = copyMe.weapon_type;
  }

  clone(drop_ids = false): Weapon {
    const new_obj = new Weapon();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }
}